<template>
    <div class="cc-products" v-if="display">
        <product v-for="product in products" v-bind:key="calculateKey(product)" :product="product" />
    </div>
</template>

<script>
    import {mapState} from 'vuex';

    import Product from "./Product";

    export default {
        components: {
            Product,
        },
        computed: {
            ...mapState({
                translations: state => state.translations,
                products: state => state.products,
            }),
            display: function () {
                return this.products && this.products.length;
            },
        },
        methods: {
            calculateKey: function(product) {
                if (product.id_attribute) {
                    return `${product.id}_${product.id_attribute}`;
                }

                return product.id;
            },
        },
    };
</script>

<style lang="scss" scoped="scoped">
    @import "./scss/components/products";
</style>
